// @ts-nocheck
import styled from 'styled-components';
import Logo from '../../common/Logo';

/**
 * This is a styled wrapper around the page. It makes the page responsive.
 */
export const PageWrapper = styled.div`
  display: flex;
  height: 100vh;
  flex-wrap: wrap;

  @media all and (min-width: 900px) {
    flex-wrap: nowrap;
  }
`;

/**
 * This is the right part that holds e.g. result charts, parameter table or form components.
 */
export const WhiteFlexSlot = styled.div`
  background-color: ${(props) => props.theme.palette.common.white};
  display: flex;
  flex: 4 1 auto;
`;

/**
 * This is the left part that holds the menu.
 */
export const MenuSlot = styled.div<{ $isCollapsed?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  background-color: ${(props) => props.theme.palette.primary.main};
  flex: ${(props) => (props.$isCollapsed ? '0 0 50px' : '0 0 clamp(360px, 20vw, 576px)')};

  ${(props) => props.theme.breakpoints.down('lg')} and (orientation: portrait) {
    flex: 0 0 100%;
  }
  ${Logo} {
    width: 100%;
  }
  transition: flex 0.5s;
`;
export const MenuSlotDark = styled(MenuSlot)`
  background-color: ${(props) => props.theme.palette.secondary.main};
`;
export const NavSlot = styled.div`
  display: flex;
  flex-direction: column;
`;
